webpackJsonp([28],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__(18);



var _INIT_BUYCART$ADD_CAR;



/* harmony default export */ __webpack_exports__["a"] = (_INIT_BUYCART$ADD_CAR = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* INIT_BUYCART */], function (state) {
  var initCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* getStore */])('buyCart');
  if (initCart) {
    state.cartList = JSON.parse(initCart);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ADD_CART */], function (state, _ref) {
  var productId = _ref.productId,
      salePrice = _ref.salePrice,
      productName = _ref.productName,
      productImg = _ref.productImg,
      _ref$productNum = _ref.productNum,
      productNum = _ref$productNum === undefined ? 1 : _ref$productNum;

  var cart = state.cartList; // 购物车
  var falg = true;
  var goods = {
    productId: productId,
    salePrice: salePrice,
    productName: productName,
    productImg: productImg
  };
  if (cart.length) {
    // 有内容
    cart.forEach(function (item) {
      if (item.productId === productId) {
        if (item.productNum >= 0) {
          falg = false;
          item.productNum += productNum;
        }
      }
    });
  }
  if (!cart.length || falg) {
    goods.productNum = productNum;
    goods.checked = '1';
    cart.push(goods);
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', cart);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ADD_ANIMATION */], function (state, _ref2) {
  var moveShow = _ref2.moveShow,
      elLeft = _ref2.elLeft,
      elTop = _ref2.elTop,
      img = _ref2.img,
      cartPositionT = _ref2.cartPositionT,
      cartPositionL = _ref2.cartPositionL,
      receiveInCart = _ref2.receiveInCart;

  state.showMoveImg = moveShow;
  if (elLeft) {
    state.elLeft = elLeft;
    state.elTop = elTop;
  }
  state.moveImgUrl = img;
  state.receiveInCart = receiveInCart;
  if (cartPositionT) {
    state.cartPositionT = cartPositionT;
    state.cartPositionL = cartPositionL;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SHOW_CART */], function (state, _ref3) {
  var showCart = _ref3.showCart;

  // let timer = null
  state.showCart = showCart;
  // clearTimeout(timer)
  // if (showCart) {
  //   timer = setTimeout(() => {
  //     state.showCart = false
  //   }, 5000)
  // }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* REDUCE_CART */], function (state, _ref4) {
  var productId = _ref4.productId;

  var cart = state.cartList;
  cart.forEach(function (item, i) {
    if (item.productId === productId) {
      if (item.productNum > 1) {
        item.productNum--;
      } else {
        cart.splice(i, 1);
      }
    }
  });
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* EDIT_CART */], function (state, _ref5) {
  var productId = _ref5.productId,
      productNum = _ref5.productNum,
      checked = _ref5.checked;

  var cart = state.cartList;
  if (productNum) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        item.productNum = productNum;
        item.checked = checked;
      }
    });
  } else if (productId) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        cart.splice(i, 1);
      }
    });
  } else {
    cart.forEach(function (item) {
      item.checked = checked ? '1' : '0';
    });
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* RECORD_USERINFO */], function (state, info) {
  state.userInfo = info;
  state.login = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('userInfo', info);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* GET_USERINFO */], function (state, info) {
  if (state.userInfo && state.userInfo.username !== info.username) {
    return;
  }
  if (!state.login) {
    return;
  }
  if (!info.message) {
    state.userInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, info);
  } else {
    state.userInfo = null;
  }
}), _INIT_BUYCART$ADD_CAR);

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "main"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * 存储localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return userLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loginOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return upload; });
/* unused harmony export updateheadimage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return productHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return navList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return recommend; });
/* unused harmony export geetest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public__ = __webpack_require__(64);

// 登陆
var userLogin = function userLogin(params) {
  // return http.fetchPost('/member/login', params)
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchPost('/api/v1/mall/user/login', params);
};
// 退出登陆
var loginOut = function loginOut(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/member/loginOut', params);
};
// 用户信息
var userInfo = function userInfo(params) {
  // return http.fetchGet('/member/checkLogin', params)
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/api/v1/mall/user/checkLogin', params);
};
// 注册账号
var register = function register(params) {
  // return http.fetchPost('/member/register', params)
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchPost('/api/v1/mall/user/register', params);
};
// 上传图片
var upload = function upload(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchPost('/member/imgaeUpload', params);
};
// 修改头像
var updateheadimage = function updateheadimage(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchPost('/member/updateheadimage', params);
};
// 捐赠列表
// export const thanksList = (params) => {
//   return http.fetchGet('/member/thanks', params)
// }
// 首页接口
var productHome = function productHome(params) {
  // return http.fetchGet('/goods/home', params)
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/api/v1/mall/home/list', params);
};
// 首页接口
var navList = function navList(params) {
  // return http.fetchGet('/goods/navList', params)
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/api/v1/mall/home/navList', params);
};
// 推荐板块
var recommend = function recommend(params) {
  // return http.fetchGet('/goods/recommend', params)
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/api/v1/mall/goods/search', params);
};
// 捐赠板块
// export const thank = (params) => {
//   return http.fetchGet('/goods/thank', params)
// }
// 极验验证码
var geetest = function geetest(params) {
  // return http.fetchGet('/member/geetestInit?t=' + (new Date()).getTime(), params)
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/api/v1/mall/user/geetestInit?t=' + new Date().getTime(), params);
};

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(139);


var Index = function Index() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 170));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 151));
};
var Register = function Register() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 152));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 150));
};
var GoodS = function GoodS() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 148));
};
var goodsDetails = function goodsDetails() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 149));
};
var Cart = function Cart() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 146));
};
var order = function order() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 154));
};
var user = function user() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 169));
};
var orderList = function orderList() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 166));
};
var information = function information() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 165));
};
var addressList = function addressList() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 162));
};
var coupon = function coupon() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 164));
};
var aihuishou = function aihuishou() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 163));
};
var support = function support() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 168));
};
var checkout = function checkout() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 147));
};
var payment = function payment() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 155));
};
var paysuccess = function paysuccess() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 156));
};
var Search = function Search() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 161));
};
var RefreshSearch = function RefreshSearch() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 160));
};
var RefreshGoods = function RefreshGoods() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 159));
};
var orderDetail = function orderDetail() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 167));
};
var Alipay = function Alipay() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 153));
};
var Wechat = function Wechat() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 158));
};
var QQpay = function QQpay() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 157));
};
var About = function About() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 144));
};
var Privacy = function Privacy() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 145));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: Index,
    name: 'index',
    redirect: '/home',
    children: [{ path: 'home', component: Home }, { path: 'goods', component: GoodS }, { path: 'goodsDetails', name: 'goodsDetails', component: goodsDetails }, { path: '/refreshgoods', name: 'refreshgoods', component: RefreshGoods }]
  }, { path: '/login', name: 'login', component: Login }, { path: '/register', name: 'register', component: Register }, { path: '/cart', name: 'cart', component: Cart }, { path: '/refreshsearch', name: 'refreshsearch', component: RefreshSearch }, {
    path: '/order',
    name: 'order',
    component: order,
    children: [{ path: 'paysuccess', name: 'paysuccess', component: paysuccess }, { path: 'payment', name: 'payment', component: payment }, { path: '/search', name: 'search', component: Search }, { path: 'alipay', name: 'alipay', component: Alipay }, { path: 'wechat', name: 'wechat', component: Wechat }, { path: 'qqpay', name: 'qqpay', component: QQpay }]
  }, {
    path: '/user',
    name: 'user',
    component: user,
    redirect: '/user/orderList',
    children: [{ path: 'orderList', name: '订单列表', component: orderList }, { path: 'orderDetail', name: '订单详情', component: orderDetail }, { path: 'information', name: '账户资料', component: information }, { path: 'addressList', name: '收货地址', component: addressList }, { path: 'coupon', name: '我的优惠', component: coupon }, { path: 'support', name: '售后服务', component: support }, { path: 'aihuishou', name: '以旧换新', component: aihuishou }]
  }, { path: '/checkout', name: 'checkout', component: checkout }, { path: '/about', name: 'about', component: About }, { path: '/privacy', name: 'privacy', component: Privacy }, { path: '*', redirect: '/home' }]
}));

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action__ = __webpack_require__(98);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  login: false, // 是否登录
  userInfo: null, // 用户信息
  cartList: [], // 加入购物车列表
  showMoveImg: false, // 显示飞入图片
  elLeft: 0,
  elTop: 0,
  moveImgUrl: null,
  cartPositionT: 0, // 购物车位置
  cartPositionL: 0,
  receiveInCart: false, // 是否进入购物车
  showCart: false // 是否显示购物车
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  action: __WEBPACK_IMPORTED_MODULE_3__action__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
}));

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(62)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(138),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.timeout = 10000;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded';
/* harmony default export */ __webpack_exports__["a"] = ({
  fetchGet: function fetchGet(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  fetchPost: function fetchPost(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_index_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store___ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_storage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_content_placeholders__ = __webpack_require__(57);












// import { Loading, Message, Notification } from 'element-ui'
// import { Button, Pagination, Checkbox, Icon, Autocomplete, Loading, Message, Notification, Steps, Step, Table, TableColumn, Input, Dialog, Select, Option } from 'element-ui'


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_content_placeholders__["default"]);
// Vue.use(Button)
// Vue.use(Pagination)
// Vue.use(Checkbox)
// Vue.use(Icon)
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default.a);
// Vue.use(Autocomplete)
// Vue.use(Steps)
// Vue.use(Step)
// Vue.use(Table)
// Vue.use(TableColumn)
// Vue.use(Input)
// Vue.use(Dialog)
// Vue.use(Select)
// Vue.use(Option)
// Vue.use(Loading.directive)
// Vue.prototype.$loading = Loading.service
// Vue.prototype.$notify = Notification
// Vue.prototype.$message = Message
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload__["a" /* default */], {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: '/static/images/load.gif'
  // attempt: 1
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
var whiteList = ['/home', '/goods', '/login', '/register', '/goodsDetails', '/search', '/refreshsearch', '/refreshgoods', '/about', '/privacy']; // 不需要登陆的页面
__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  var params = {
    params: {
      token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_storage__["a" /* getStore */])('token')
    }
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__api__["a" /* userInfo */])(params).then(function (res) {
    console.log(res);
    if (res.result.state !== 1) {
      // 没登录
      if (whiteList.indexOf(to.path) !== -1) {
        // 白名单
        next();
      } else {
        next('/login');
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */].commit('RECORD_USERINFO', { info: res.result });
      if (to.path === '/login') {
        //  跳转到
        next({ path: '/' });
      }
      next();
    }
  });

  // next()
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  }
});

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_BUYCART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECORD_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REDUCE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EDIT_CART; });
var INIT_BUYCART = 'INIT_BUYCART';
var ADD_CART = 'ADD_CART';
var GET_USERINFO = 'GET_USERINFO';
var RECORD_USERINFO = 'RECORD_USERINFO';
var ADD_ANIMATION = 'ADD_ANIMATION';
var SHOW_CART = 'SHOW_CART';
var REDUCE_CART = 'REDUCE_CART';
var EDIT_CART = 'EDIT_CART';

/***/ })

},[97]);


// WEBPACK FOOTER //
// static/js/app.b6f7013866f2f764c0d9.js